import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { AdmihairBaseComponent } from '../../../admihair-base.component';
import { ErroService } from 'src/app/admihair/service/erro.service';
import { UtilStorageService } from 'src/app/admihair/service/util-storage.service';
import { Table } from 'primeng/table';
import { ConfirmationService, SelectItem } from 'primeng/api';
import { FolhaPagamento, ItemFolhaPagamento } from 'src/app/admihair/api/dto/folha-pagamento';
import { FolhaPagamentoService } from 'src/app/admihair/service/folha-pagamento.service';
import { TipoPagamentoService } from 'src/app/admihair/service/tipo-pagamento.service';
import { TipoPagamento } from 'src/app/admihair/api/dto/tipo-pagamento';
import { FluxoFinanceiroService } from 'src/app/admihair/service/fluxo-financeiro.service';
import { ItemPagamentoFolhaRequest, PagamentoFolhaRequest } from 'src/app/admihair/api/dto/folha-pagamento-request';

interface expandedRows {
  [key: string]: boolean;
}


@Component({
  selector: 'app-pagamento-folha-listar',
  templateUrl: './pagamento-folha-listar.component.html',
  styleUrls: ['./pagamento-folha-listar.component.scss']
})
export class PagamentoFolhaListarComponent extends AdmihairBaseComponent implements OnInit {

  @ViewChild('filter') filter!: ElementRef;
  permissaoFolha: boolean = false;
  loading: boolean = false;
  lancamentosFolha: FolhaPagamento[] = [];
  filtroCompetencia: Date = new Date();

  expandedRows: expandedRows = {};
  isExpanded: boolean = false;

  exibirDialog: boolean = false;
  loadingDialog: boolean = false;
  loadingTableDialog: boolean = false;
  progressoRequisicaoSalvarDialog: boolean = false;

  listaLancamentosAPagar: ItemPagamentoFolhaRequest[] = [];
  listaLancamentosAPagarSelecionados: ItemPagamentoFolhaRequest[] = [];

  listaTiposPagamento: TipoPagamento[] = [];
  tipoPagamentoSelecionado?: TipoPagamento;
  dataFluxoSelecionada: Date = new Date();

  tiposFolha: SelectItem[] = [
    { label: 'TODAS', value: 'TODAS' },
    { label: 'EMPRESA', value: 'FOLHA_EMPRESA' },
    { label: 'CONTRATOS', value: 'FOLHA_CONTRATOS' }];
  tipoFolhaSelecionado: string = 'TODAS';

  loadingRelatorioEmpresa: boolean = false;
  loadingRelatorioContrato: boolean = false;

  constructor(private folhaPagamentoService: FolhaPagamentoService,
    private tipoPagamentoService: TipoPagamentoService,
    private fluxoFinanceiroService: FluxoFinanceiroService,
    private confirmationService: ConfirmationService,
    erroService: ErroService,
    storageService: UtilStorageService) {
    super(erroService, storageService)
  }

  ngOnInit(): void {
    this.permissaoFolha = this.verificarPermissao('PERM_PAGAMENTO_FOLHA');
    this.listar();
  }

  listar() {
    this.loading = true
    this.folhaPagamentoService.listarRegistros(
      this.getEmpresa().id,
      this.filtroCompetencia,
      this.tipoFolhaSelecionado
    ).subscribe({
      next: (data: FolhaPagamento[]) => {
        console.log(data)
        this.lancamentosFolha = data;
        this.loading = false;
      },
      error: (err: any) => {
        this.loading = false;
        this.exibirMensagemErro(err);
      }
    });
  }

  abrirDialogPagamento() {
    this.listaLancamentosAPagar = [];
    this.listaLancamentosAPagarSelecionados = [];
    this.tipoPagamentoSelecionado = undefined;
    this.exibirDialog = true;
    this.listarTiposPagamento();
    this.listarAPagar();
  }

  listarTiposPagamento() {
    this.tipoPagamentoService.listarPorEmpresaEOperacaoInterno(
      this.getEmpresa().id
    ).subscribe({
      next: (data: TipoPagamento[]) => {
        this.listaTiposPagamento = data;
      },
      error: (err: any) => {
        this.exibirMensagemErro(err);
      }
    })
  }

  listarAPagar() {
    this.loadingTableDialog = true;
    this.folhaPagamentoService.listarRegistrosAPagar(
      this.getEmpresa().id, this.filtroCompetencia
    ).subscribe({
      next: (data: FolhaPagamento[]) => {

        this.listaLancamentosAPagar = data.map(registro => ({
          id: registro.id,
          origemRegistro: registro.origemRegistro,
          nomeRazaoSocial: registro.nomeRazaoSocial,
          valorAPagar: (registro.valorLiquido ?? 0) - (registro.valorPago ?? 0),
          competencia: registro.competencia,
          empresaId: registro.empresaId
        }));
        this.loadingTableDialog = false;

      },
      error: (err: any) => {
        this.loadingTableDialog = false;
        this.exibirMensagemErro(err);
      }
    });
  }

  pagarLancamentos() {
    this.progressoRequisicaoSalvarDialog = true;

    const pagamentoFolhaRequest: PagamentoFolhaRequest = {
      dataFluxo: this.dataFluxoSelecionada,
      empresaId: this.getEmpresa().id,
      lista: this.listaLancamentosAPagarSelecionados
    }

    this.folhaPagamentoService.pagarFolha(
      this.getEmpresa().id,
      pagamentoFolhaRequest
    ).subscribe({
      next: () => {
        this.listar();
        this.progressoRequisicaoSalvarDialog = false;
        this.exibirDialog = false;
        this.exibirMensagemSucesso();
      },
      error: (err: any) => {
        this.progressoRequisicaoSalvarDialog = false;
        this.exibirDialog = false;
        this.exibirMensagemErro(err);
      }
    })

  }

  excluirRegistroFolha(item: FolhaPagamento) {
    this.confirmationService.confirm({
      message: 'Tem certeza que seja excluir?',
      header: 'Confirmação',
      acceptLabel: 'Sim',
      rejectLabel: 'Não',
      icon: 'pi pi-info-circle',
      accept: () => {
        this.folhaPagamentoService.excluir(item.id, item.origemRegistro)
          .subscribe({
            next: () => {
              this.listar();
              this.exibirMensagemSucesso();
            },
            error: (err: any) => {
              this.exibirMensagemErro(err);
            }
          })
      }
    });
  }

  excluirPagamentoFolha(item: ItemFolhaPagamento) {
    this.confirmationService.confirm({
      message: 'Tem certeza que seja excluir?',
      header: 'Confirmação',
      acceptLabel: 'Sim',
      rejectLabel: 'Não',
      icon: 'pi pi-info-circle',
      accept: () => {
        this.folhaPagamentoService.excluirPagamento(
          item.controle,
          item.id,
          item.tipoControle
        )
          .subscribe({
            next: () => {
              this.listar();
              this.exibirMensagemSucesso();
            },
            error: (err: any) => {
              this.exibirMensagemErro(err);
            }
          })
      }
    });
  }

  alterarTipoPagamento() {
    this.listaLancamentosAPagar.forEach(item =>
      item.tipoPagamento = this.tipoPagamentoSelecionado);
  }

  buscar(table: Table, event: Event) {
    table.filterGlobal((event.target as HTMLInputElement).value, 'contains');
  }

  limpar(table: Table) {
    table.clear();
    this.filter.nativeElement.value = '';
  }

  obterRelatorio(tipoFolha: string) {
    if (tipoFolha === 'FOLHA_EMPRESA') {
      this.loadingRelatorioEmpresa = true;
    } else {
      this.loadingRelatorioContrato = true;
    }
    const empresa = this.getEmpresa();
    this.folhaPagamentoService.obterRelatorio(
      empresa.id,
      tipoFolha,
      this.filtroCompetencia
    ).subscribe({
      next: (data: any) => {

        const blob = new Blob([data], { type: 'application/pdf' });
        const url = window.URL.createObjectURL(blob);
        window.open(url, '_blank');
        window.URL.revokeObjectURL(url);
        this.loadingRelatorioEmpresa = false;
        this.loadingRelatorioContrato = false;
      },
      error: (err: any) => {
        const reader = new FileReader();
        reader.onload = () => {
          const jsonError = JSON.parse(reader.result as string);
          console.log(jsonError)
          err.error = jsonError;
          this.exibirMensagemErro(err);

        };
        reader.readAsText(err.error);
        this.loadingRelatorioEmpresa = false;
        this.loadingRelatorioContrato = false;
      }
    })
  }

}
